/**
 * TCR-1528: BE hỗ trợ tìm khách hàng bằng text KHÔNG DẤU (gõ "fan tam" ra
 * khách "Fan tâm tổ chức"). Regex highlight nguyên văn ở FE không khớp được
 * trong trường hợp này. `buildAccentInsensitivePattern` build ra một pattern
 * regex (dạng string, chưa bọc `RegExp`) coi mỗi ký tự nguyên âm/`d` như một
 * character class gồm mọi biến thể có dấu, để `new RegExp(pattern, 'gi')` vẫn
 * khớp được cả bản có dấu lẫn không dấu của text hiển thị.
 */

const ACCENT_MAP: Record<string, string> = {
  a: '[aàáạảãâầấậẩẫăằắặẳẵ]',
  d: '[dđ]',
  e: '[eèéẹẻẽêềếệểễ]',
  i: '[iìíịỉĩ]',
  o: '[oòóọỏõôồốộổỗơờớợởỡ]',
  u: '[uùúụủũưừứựửữ]',
  y: '[yỳýỵỷỹ]',
};

const REGEX_SPECIAL = /[.*+?^${}()|[\]\\]/;

function stripAccents(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'd')
    .toLowerCase();
}

export function buildAccentInsensitivePattern(raw: string): string | null {
  if (!raw) return null;
  const collapsed = raw.trim().replace(/\s+/g, ' ');
  if (!collapsed) return null;

  const normalized = stripAccents(collapsed);

  let pattern = '';
  for (const ch of normalized) {
    if (ACCENT_MAP[ch]) {
      pattern += ACCENT_MAP[ch];
    } else if (REGEX_SPECIAL.test(ch)) {
      pattern += `\\${ch}`;
    } else {
      pattern += ch;
    }
  }
  return pattern;
}
